import React, { useCallback, useEffect, useState } from "react";
import { Button, Spinner } from "reactstrap";

import SectionCard from "components/SectionCard";
import ApiCotacaoForm, { API_VAZIA, validarApiCotacao, apiCotacaoParaPayload } from "components/ApiCotacaoForm";
import { AUTOPILOT_COLORS } from "components/autopilot/styles";
import { useToast } from "hooks/toast";
import { redeApiCotacao, salvarRedeApiCotacao, mensagemErro } from "services/meuFreteApi";

// Aba "API de cotação" do Cadastro do MeuFrete (PO1-3650, épico PO1-3359): a
// transportadora declara se tem API (tipo, documentação, contato técnico).
// Só a declaração, que vira o selo "Tem API" no Sourcing; a integração em si
// fica para depois.

const labelStyle = { fontSize: "0.78rem", color: AUTOPILOT_COLORS.muted, marginBottom: 4 };
const textoStyle = { color: AUTOPILOT_COLORS.text, fontSize: "0.88rem" };
const stateBoxStyle = { display: "flex", alignItems: "center", gap: "0.6rem", padding: "1rem 0.25rem", color: AUTOPILOT_COLORS.muted, fontSize: "0.9rem" };

export default function AbaApiCotacao() {
  const { addToast } = useToast();
  const [api, setApi] = useState(API_VAZIA);
  const [erros, setErros] = useState({});
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erroCarga, setErroCarga] = useState("");
  const [sujo, setSujo] = useState(false);

  const carregar = useCallback(async () => {
    setLoading(true);
    setErroCarga("");
    try {
      const a = await redeApiCotacao();
      setApi({ ...API_VAZIA, ...(a || {}) });
      setSujo(false);
    } catch (err) {
      setErroCarga(mensagemErro(err, "Não foi possível carregar a declaração de API."));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  const salvar = async () => {
    const e = validarApiCotacao(api);
    setErros(e);
    if (Object.keys(e).length) return;
    setSalvando(true);
    try {
      const a = await salvarRedeApiCotacao(apiCotacaoParaPayload(api));
      setApi({ ...API_VAZIA, ...(a || apiCotacaoParaPayload(api)) });
      setSujo(false);
      addToast({ place: "tr", type: "success", title: "API de cotação salva", description: api.temApi ? "O selo \"Tem API\" já aparece para os embarcadores no Sourcing." : "Sem API declarada." });
    } catch (err) {
      const d = (err && err.response && err.response.data) || {};
      if (d.field) setErros({ [d.field]: d.error || "Confira este campo." });
      addToast({ place: "tr", type: "danger", title: "Não foi possível salvar", description: mensagemErro(err) });
    } finally {
      setSalvando(false);
    }
  };

  if (loading) {
    return (
      <div style={stateBoxStyle}>
        <Spinner size="sm" style={{ color: AUTOPILOT_COLORS.accent }} />
        <span>Carregando…</span>
      </div>
    );
  }
  if (erroCarga) {
    return (
      <div style={stateBoxStyle} role="alert">
        {erroCarga}{" "}
        <Button size="sm" color="info" outline onClick={carregar}>
          Tentar de novo
        </Button>
      </div>
    );
  }

  return (
    <SectionCard
      eyebrow="Rede Everlog"
      title="API de cotação"
      description="Se a sua transportadora cota por API, declare aqui o tipo e o contato técnico. Os embarcadores veem o selo “Tem API” no Sourcing; a integração é combinada depois, caso a caso."
      action={
        <Button size="sm" color="info" onClick={salvar} disabled={salvando || !sujo}>
          {salvando ? <Spinner size="sm" /> : "Salvar"}
        </Button>
      }
    >
      <ApiCotacaoForm
        value={api}
        onChange={(v) => {
          setApi(v);
          setErros({});
          setSujo(true);
        }}
        erros={erros}
        disabled={salvando}
        labelStyle={labelStyle}
        textoStyle={textoStyle}
      />
    </SectionCard>
  );
}
